import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map, Observable } from 'rxjs';
import { CurrencyCode } from '@cp/shared/data-access/shared/enums';
import { SharedSelectors } from '@cp/shared/data-access/+state/selectors';
import { DivisionService } from '@cp/shared/data-access/division/division.service';
import { PayRatesTouchlessGroupHttpModel } from '@cp/shared/data-access/http/dashboard/dashboard-http.models';

interface PayRatesViewModel {
  groups: Array<PayRatesTouchlessGroupHttpModel>;
  currencyCode: CurrencyCode;
  payRatesUrl: string;
}

@Component({
  selector: 'cp-pay-rates-touchless',
  templateUrl: './pay-rates-touchless.component.html',
  styleUrls: ['./pay-rates-touchless.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayRatesTouchlessComponent {
  public readonly vm$: Observable<PayRatesViewModel> = combineLatest([
    this._store.select(SharedSelectors.selectTouchlessPayRates),
    this._store.select(SharedSelectors.selectDivision),
    this._store.select(SharedSelectors.selectDivisionCurrencyCode),
  ]).pipe(
    map(([{ groups }, division, currencyCode]) => ({
      groups: groups ?? [],
      currencyCode,
      payRatesUrl: this._divisionService.getConfigEntry(
        'payRatesUrl',
        division,
      ),
    })),
  );

  constructor(
    private _store: Store,
    private _divisionService: DivisionService,
  ) {}
}
